import { LoginForm } from "@/components/auth/login-form";
import { Divider, Text } from "@/components/ui";
import { UsuariosDemoCard } from "./UsuariosDemoCard";

/**
 * Panel derecho de /login · form de autenticación, divisor, card de
 * usuarios demo y footer de soporte. En mobile (sin panel marketing a la
 * izquierda) muestra el nombre del portal como encabezado.
 */
export function LoginFormPanel() {
  return (
    <main className="flex min-h-screen items-center justify-center px-4 py-8 md:h-full">
      <div className="multiva-fade-up flex w-full max-w-100 flex-col gap-6">
        <p className="text-sm font-semibold text-foreground md:hidden">Portal de proveedores</p>

        <div className="flex flex-col gap-1.5">
          {/* h1 (antes h2): es el encabezado principal de la página · a11y (page-has-heading-one). */}
          <h1 className="text-[22px] font-bold leading-tight tracking-[-0.01em] text-foreground">Bienvenido(a)</h1>
          <Text c="dimmed" size="sm">
            Ingresa con tu cuenta corporativa para continuar.
          </Text>
        </div>

        <LoginForm />

        <Divider label={<span className="text-xs font-medium text-muted-foreground">Usuarios de demo</span>} />

        <UsuariosDemoCard />

        <Text size="xs" c="dimmed" ta="center">
          ¿Problemas para entrar?{" "}
          <a href="mailto:soporte@proveedores.test" className="font-medium text-multiva-700 underline underline-offset-2 dark:text-multiva-400">
            Contacta a soporte
          </a>
        </Text>
      </div>
    </main>
  );
}
